{
	"title": "Sikre ansvarlighet ved å installere en karbonbank",
	"description": "Heidelberg Materials har tatt grundige tiltak for å garantere troverdigheten til karbonreduksjoner generert av vår CCS-sementfabrikk. For å forhindre enhver mulighet for dobbeltregnskap, har vi implementert en sikker virtuell karbonbank på en offentlig distribuert hovedbok.",
	"traceabilityTitle": "Sporbarhet av karbonreduksjoner"
}
